import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// import { authLogin } from "../../api/auth/authApi";
import { authLogin } from "./authApi";
import { logoutUserAPI, refreshTokenAPI } from "../../../api/tokenService";

// LOGIN
export const authLoginAsync = createAsyncThunk(
  "auth/login",
  async ({ email, password }, thunkAPI) => {
    try {
      const data = await authLogin(email, password);
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data);
    }
  }
);

// REFRESH TOKEN
export const refreshTokenAsync = createAsyncThunk(
  "auth/refreshToken",
  async ({ refresh_token }, thunkAPI) => {
    try {
      const data = await refreshTokenAPI(refresh_token);
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data);
    }
  }
);

// LOGOUT
export const logoutUserAsync = createAsyncThunk(
  "auth/logout",
  async ({ refresh_token }, thunkAPI) => {
    try {
      const data = await logoutUserAPI(refresh_token);
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data);
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // LOGIN
      .addCase(authLoginAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(authLoginAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;

        localStorage.setItem("token", action.payload.token);
        localStorage.setItem("refresh_token", action.payload.refresh_token);
      })
      .addCase(authLoginAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message;
      })

      // LOGOUT
      .addCase(logoutUserAsync.fulfilled, () => {
        localStorage.clear();
      });
  },
});

export default authSlice.reducer;
